import React, { memo } from "react";

import styled from "styled-components";

import {
  AccordionProps,
  Accordion as ODSAccordion,
  Text,
} from "@origin-digital/ods-core";
import { IconChevronDown } from "@origin-digital/ods-icons";

type VerticalAccordionProps = AccordionProps & {
  showDetails?: boolean;
};

const VerticalODSAccordion = styled(ODSAccordion)<VerticalAccordionProps>(
  ({ theme }) => ({
    "&& ": {
      border: `1px solid ${theme.palette.grey[200]}`,
      borderRadius: 24,

      "& .MuiAccordionSummary-root": {
        flexFlow: "column",
        paddingBottom: 0,

        "& .MuiAccordionSummary-content": {
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
          margin: 0,
          padding: 12,
          width: "calc(100% - 24px)",
        },
        "& .MuiAccordionSummary-expandIconWrapper": {
          alignItems: "center",
          border: "none",
          padding: "12px 0",
          justifyContent: "center",
          width: "100%",
        },
      },

      "&.hide-details .MuiAccordionDetails-root": {
        display: "none",
      },
    },
  })
);

const VerticalAccordion = memo(
  ({
    id,
    summary,
    children,
    showDetails = true,
    ...restProps
  }: VerticalAccordionProps) => {
    return (
      <>
        <VerticalODSAccordion
          id={id}
          summary={summary}
          className={showDetails ? "" : "hide-details"}
          muiProps={{
            accordionSummaryProps: {
              expandIcon: <IconChevronDown color="primary" />,
            },
          }}
          {...restProps}
        >
          <Text>{children}</Text>
        </VerticalODSAccordion>
      </>
    );
  }
);

export { VerticalAccordion };
